module.exports = __webpack_public_path__ + "static/media/trade-action.01bd1e4a.png";